import HomeSearch from '../../components/elements/HomeSearch'
import Navbar from '../../layout/Navbar'
import Banner from '../../assets/images/live.png'
import Icon from '../../components/Icon'
import { faArrowLeft, faArrowRight, faDotCircle, } from '@fortawesome/free-solid-svg-icons'
import BlogCard from '../../components/cards/BlogCard'
import { useFetch } from '../../hooks/useFetch'
import { recentBlogs, upcomingToursAndEvents } from '../../apis'
import TrendingCard from '../../components/cards/TrendingCard'
import { useState } from 'react'


export default () => {
    const [activeCarousel, setActiveCarousel] = useState(0)

    const [blogs] = useFetch(recentBlogs, [])
    const [upcommingToursAndEvent] = useFetch(upcomingToursAndEvents, [])
    const darshans = [
        "https://www.youtube.com/embed/8pSi0xZm6ak?si=NITVUOTWRHUK0b_Q",
        "https://www.youtube.com/embed/fLgoT2MQFT0?si=JoqxrB8BfoYFLz9l",
        "https://www.youtube.com/embed/elZXysfp2pI?si=xQx2qkpiinRPSDO-",
        "https://www.youtube.com/embed/nHmvLlmh6dk?si=-0lqNk8-yrQ4nR7i"
    ]

    return (
        <>
            <Navbar />

            <section className="w-100 postion-relative">
                <div className="d-flex justify-content-center align-items-end w-100" style={{ height: "100vh", background: `url(${Banner})` }}>
                    <div className="mb-5 pb-5">
                        <div className="namaste mb-4 mx-5 px-5">Experience the Divine</div>
                        <HomeSearch />
                    </div>
                </div>
                <div className='position-absolute d-flex align-items-center bg-black py-1 px-3 rounded-5' style={{ bottom: "20px", right: "20px" }}>
                    <Icon icon={faDotCircle} className="text-danger fs-8 me-1" />
                    <h3 className='mb-0 text-white'>LIVE</h3>
                </div>
            </section>

            <section className='container'>
                <div className=' my-4'>
                    <h1 className='custom-text-color'>Watch Live Darshan</h1>
                </div>

                <div className='mb-5 pb-5'>
                    <div className='position-relative m-5'>
                        <div className='' style={{ height: "500px"}}>
                            <iframe autoplay className='rounded-4' width="100%" height="100%" src={ darshans[activeCarousel] } title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div className='position-absolute d-flex align-items-center bg-black py-1 px-3 rounded-5' style={{ top: "20px", left: "20px" }}>
                            <Icon icon={faDotCircle} className="text-danger fs-8 me-1" />
                            <h3 className='mb-0 text-white'>LIVE</h3>
                        </div>
                    </div>
                    <div className='d-flex justify-content-center align-items-center'>
                        <div className="bg-saffron rounded-circle p-3 mx-2 d-flex  align-items-center justify-content-center cursor-pointer" style={{ width: "50px", height: "50px" }} onClick={() => setActiveCarousel( activeCarousel > 0 ? activeCarousel - 1 : 0 )}><Icon icon={faArrowLeft} className="text-white" /></div>
                        <div className="bg-saffron rounded-circle p-3 mx-2 d-flex  align-items-center justify-content-center cursor-pointer" style={{ width: "50px", height: "50px" }} onClick={() => setActiveCarousel( (activeCarousel < darshans.length - 1) ? activeCarousel + 1 : darshans.length -1  )}><Icon icon={faArrowRight} className="text-white" /></div>
                        <h5 className='ms-3'>{ activeCarousel + 1} / { darshans.length }</h5>
                    </div>
                </div>





            </section>
            {/* <div className='overflow-auto scrollbar-hidden'>
                <div className="ms-5 d-flex w-100">
                    {
                        [
                            { name: "Krishna Balram Mandir", video: "https://dham-bkt.s3.amazonaws.com/IMG_6029+(1).mp4"},
                            { name: "Badrinath Tour", video: "https://dham-bkt.s3.amazonaws.com/lv_0_20240926194928.mp4"},
                            { namw: "Ram Mandir", video: "https://dham-bkt.s3.amazonaws.com/Masroor+Temple+(1)+(1).mp4"}
                        ].map(( reel, i ) =>
                            <div className="p-0" key={i}>
                                <div className='m-2 position-relative rounded-4'>
                                    <div className='' style={{ height: "500px", width: "20%"  }} >
                                    <video class="rounded-4"  autoPlay muted loop  style={{ width: "auto", height: "100%", objectFit: "cover", margin: "0px auto" }} >
                                        <source src={reel.video} />
                                    </video>

                                    </div>
                                    <div className='p-2 position-absolute bottom-0 text-white darshan-description w-100 rounded-4'>
                                        <p className='bold mb-2'>{ reel.name }</p>
                                        <p className=' fs-9'><Icon icon={faCalendarAlt} className="text-saffron me-2" />Starting from Jul19, 2024 to Jul24, 2024</p>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div> */}



            <div className='overflow-auto scrollbar-hidden mt-5'>
                <div className="ms-5 d-flex  w-100">
                    {
                        upcommingToursAndEvent?.map((tour, i) =>
                            <div className=' col-lg-8 col-md-12' >
                                <TrendingCard data={tour} />
                            </div>
                        )
                    }
                </div>
            </div>

            <div className="container mt-5">
                <div className="card rounded-4 p-3">
                    <p className="custom-text-color fs-3">Latest Blog &amp; News</p>
                    <div className="">
                        <div className="d-flex overflow-auto scrollbar-hidden p-0">
                            {blogs.map((blog, i) => (
                                <div key={i} className="col-sm-12 col-md-6 col-lg-3 ">
                                    <div className="m-2">
                                        <BlogCard data={blog} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}